import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { PRODUCT } from "./data";
import MagicSparkles from "./MagicSparkles";
import { FloatingMoon, Sparkle } from "./SleepDecorations";
import { LANDING } from "@/constants/testIds";

export default function FinalOffer() {
  return (
    <section className="py-28 lg:py-36 relative overflow-hidden bg-gradient-to-br from-[#1f1430] via-[#2d1f43] to-[#1f1430]">
      <div className="absolute inset-0 stars-bg opacity-30" />
      <FloatingMoon className="absolute top-12 left-[6%]" size={220} tone="light" />
      <Sparkle className="absolute top-1/4 right-[15%] text-violet-200/60" size={28} />
      <Sparkle className="absolute bottom-1/4 left-[20%] text-amber-300/40" size={22} />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[900px] h-[600px] rounded-full bg-violet-500/20 blur-[160px]" />

      <div className="relative max-w-3xl mx-auto px-6 lg:px-8 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="font-display text-3xl lg:text-5xl text-white leading-[1.15]"
        >
          Continuar tentando descobrir tudo sozinha.
          <span className="block text-[#c4b5fd] mt-3">
            Ou finalmente seguir um caminho validado.
          </span>
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="font-display text-xl lg:text-2xl text-white/85 mt-10 leading-snug max-w-xl mx-auto"
        >
          A próxima noite vai acontecer de qualquer forma.
          <span className="block text-[#c4b5fd] mt-2">
            A diferença é o que você fará com ela.
          </span>
        </motion.p>

        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="mt-12"
        >
          <a
            href={PRODUCT.checkoutUrl}
            data-testid={LANDING.finalCta}
            className="group relative btn-shine btn-jelly cta-pulse cta-primary inline-flex px-12 py-5 text-base lg:text-lg"
          >
            <MagicSparkles />
            <span className="relative z-10">Quero começar a Jornada agora.</span>
            <ArrowRight className="w-5 h-5 relative z-10 arrow-slide" />
          </a>
          <p className="text-xs text-violet-200/70 mt-5 font-body">
            7 dias de garantia · Acesso imediato
          </p>
        </motion.div>
      </div>
    </section>
  );
}
